var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 781,
    height: 547,
    viewBox: "0 0 781 547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7247_823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681 273.5C681 237.427 662.174 202.251 627.142 172.866C592.109 143.481 542.613 121.349 485.538 109.547C428.463 97.7461 366.648 96.8632 308.694 107.021C250.74 117.18 199.528 137.874 162.183 166.225C124.839 194.576 103.219 229.174 100.332 265.206C97.4448 301.238 113.434 336.911 146.074 367.262C178.714 397.614 226.383 421.134 282.448 434.552C338.513 447.969 400.187 450.616 458.888 442.124L390.5 273.5H681Z",
    fill: "#76FFD5",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7247_823",
    x: -0.00012207,
    y: 0,
    width: 781,
    height: 547,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_7247_823"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlow);
export default __webpack_public_path__ + "static/media/Glow.7bf52a61f37b0b0926b09618913b1ea3.svg";
export { ForwardRef as ReactComponent };